import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-bhupaal-panshikar',
  templateUrl: './online-bhupaal-panshikar.component.html',
  styleUrls: ['./online-bhupaal-panshikar.component.scss']
})
export class OnlineBhupaalPanshikarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
